// Tutarları Türk formatında göster: binlik ayırıcı ".", ondalık ayırıcı ","

// Örn: formatCurrency(150000, 'USD') => "$150.000"
export function formatCurrency(value, currency) {
	const number = Number(value);
	if (value === '' || value == null || Number.isNaN(number)) return '';

	const fractionDigits = Number.isInteger(number) ? 0 : 2;
	return new Intl.NumberFormat('tr-TR', {
		...(currency ? { style: 'currency', currency } : {}),
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(number);
}

// Yazarken gösterilen hali, örn: "150000.5" => "150.000,5"
export function formatAmount(value) {
	if (!Number(value) && !String(value ?? '').includes('.')) return '';

	const [integer, decimals] = String(value).split('.');
	const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	return decimals !== undefined ? `${grouped},${decimals}` : grouped;
}

// Girilen metni ham sayıya çevir, örn: "$150.000,5" => "150000.5"
export function parseAmount(text, allowDecimals = false) {
	const [integer, ...rest] = text.replace(/[^\d,]/g, '').split(',');
	if (!allowDecimals || !rest.length) return integer;

	return `${integer}.${rest.join('').slice(0, 2)}`;
}
